'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Owner interface (omistajaliittymä) WRC-access methods
var OwnerService = exports.OwnerService = function () {
    function OwnerService(winresCloudService, $q) {
        _classCallCheck(this, OwnerService);

        this.winresCloudService = winresCloudService;
        this.$q = $q;
    }

    _createClass(OwnerService, [{
        key: 'getOwnerCustomerList',
        value: function getOwnerCustomerList(ownerNumber) {
            return this.winresCloudService.makeAuthenticatedRequest('GetOwnerCustomerList', {
                OwnerNumber: ownerNumber
            });
        }
    }, {
        key: 'getOwnerBookingList',
        value: function getOwnerBookingList(ownerNumber) {
            return this.winresCloudService.makeAuthenticatedRequest('GetOwnerBookingList', {
                OwnerNumber: ownerNumber
            },
            /*withOverlay=*/true);
        }
    }, {
        key: 'getOwnerSettlementDays',
        value: function getOwnerSettlementDays(ownerNumber) {
            return this.winresCloudService.makeAuthenticatedRequest('GetOwnerSettlementDays', {
                OwnerNumber: ownerNumber
            },
            /*withOverlay=*/true);
        }

        // Used to get the following reports in varausraportti
        //  - Omistajien varausraportti
        //  - Huoltajan varausraportti
        //  - Huoltajan 2 varausraportti
        //  - Huoltajaraportti
        //  - Omistajaraportti
        //  - Tilitystraportti

    }, {
        key: 'getOwnerReports',
        value: function getOwnerReports(ownerNumber, destinationCode, dateFrom, dateTo, dateMode, reportType, language) {
            return this.winresCloudService.makeAuthenticatedRequest('GetOwnerReports', {
                OwnerNumber: ownerNumber,
                Destination: destinationCode ? destinationCode : null,
                BeginDate: dateFrom ? dateFrom : null,
                EndDate: dateTo ? dateTo : null,
                EndDateRange: dateMode === 'departure',
                ReportType: reportType,
                Language: language
            },
            /*withOverlay=*/true);
        }

        // Used to mark huoltaja/omistajaraportti reports as processed in
        // varausraportti

    }, {
        key: 'markOwnerReport',
        value: function markOwnerReport(ownerNumber, id) {
            return this.winresCloudService.makeAuthenticatedRequest('MarkOwnerReport', {
                OwnerNumber: ownerNumber,
                ID: id
            },
            /*withOverlay=*/true);
        }

        // Gets list of destination + product.
        // Does not do what the name makes you think.

    }, {
        key: 'getOwnerKohdeAlueList',
        value: function getOwnerKohdeAlueList(ownerNumber) {
            return this.winresCloudService.makeAuthenticatedRequest('GetOrganizationDestinationList', {
                OwnerNumber: ownerNumber
            },
            /*withOverlay=*/true);
        }
    }, {
        key: 'saveOwnerKohdeAlueList',
        value: function saveOwnerKohdeAlueList(ownerNumber, kohdelist) {
            return this.winresCloudService.makeAuthenticatedRequest('StoreOrganizationDestinationList', {
                OwnerNumber: ownerNumber,
                OrganizationDestinationList: kohdelist
            });
        }
    }, {
        key: 'autocompleteOwner',
        value: function autocompleteOwner(keyword) {
            return this.winresCloudService.makeAuthenticatedRequest('AutocompleteOwner', {
                Keyword: keyword
            });
        }
    }, {
        key: 'cancelOwnerBooking',
        value: function cancelOwnerBooking(bookingNumber) {
            return this.winresCloudService.makeAuthenticatedRequest('CancelOwnerBooking', {
                BookingNumber: bookingNumber
            }, true);
        }
    }, {
        key: 'GetOwnerData',
        value: function GetOwnerData(ownerNumber, ownerName, language) {
            return this.winresCloudService.makeAuthenticatedRequest('GetOwnerData', {
                OwnerNumber: ownerNumber,
                OwnerName: ownerName,
                Language: language
            });
        }
    }, {
        key: 'GetOwnerSettings',
        value: function GetOwnerSettings() {
            return this.winresCloudService.makeAuthenticatedRequest('GetOwnerSettings', {});
        }
    }, {
        key: 'SaveOwnerSettings',
        value: function SaveOwnerSettings(settings) {
            console.log("Saving.. Sending data: SaveOwnerSettings, settings: ", settings);
            return this.winresCloudService.makeAuthenticatedRequest('SaveOwnerSettings', {
                Settings: settings
            });
        }
    }, {
        key: 'getOwnerDestAndProdData',
        value: function getOwnerDestAndProdData(destCode, prodCode) {
            return this.winresCloudService.makeAuthenticatedRequest('GetOwnerDestAndProdData', {
                DestCode: destCode,
                ProdCode: prodCode
            });
        }
    }, {
        key: 'storeOwnerDestAndProdData',
        value: function storeOwnerDestAndProdData(destCode, prodCode, data) {
            return this.winresCloudService.makeAuthenticatedRequest('StoreOwnerDestAndProdData', {
                DestCode: destCode,
                ProdCode: prodCode,
                Data: data
            });
        }
    }, {
        key: 'getOwnerDestImages',
        value: function getOwnerDestImages(destCode) {
            return this.winresCloudService.makeAuthenticatedRequest('GetOwnerDestImages', {
                DestCode: destCode
            });
        }
    }, {
        key: 'storeOwnerDestImages',
        value: function storeOwnerDestImages(destCode, images) {
            return this.winresCloudService.makeAuthenticatedRequest('StoreOwnerDestImages', {
                DestCode: destCode,
                Images: images
            });
        }

        // OwnerNumber comes from SessionID

    }, {
        key: 'getCanShowReadyButton',
        value: function getCanShowReadyButton() {
            return this.winresCloudService.makeAuthenticatedRequest('GetCanShowReadyButton', {});
        }

        // On click portal ready button

    }, {
        key: 'onReady',
        value: function onReady(DestCode) {
            return this.winresCloudService.makeAuthenticatedRequest('OnReady', {
                DestCode: DestCode
            });
        }
    }, {
        key: 'getOwnerCompanyNames',
        value: function getOwnerCompanyNames(owners) {
            var _this = this;

            return this.$q(function (resolve) {
                // Prevent no owner request.
                if (owners === '') {
                    resolve([]);
                    return;
                }

                var endpoint = 'Winres/x/Owners?SearchOwners=' + owners + '&GetCompany';

                _this.winresCloudService.get(endpoint).then(function (result) {
                    resolve(result.data);
                });
            });
        }
    }]);

    return OwnerService;
}();

OwnerService.$inject = ['winresCloudService', '$q'];


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/ownerService.js
// module id = 560
// module chunks = 2